import useConstants from '@api/hooks/useConstants';
import { getIsReferralRevampEnabled } from '@api/selectors/constants';

/** Avoid treating revamp as off while `v1/constants` is still loading. */
export const useReferralRevampState = () => {
  const { constants, isLoading } = useConstants();
  const isRevampFlagReady = !isLoading;
  const isRevampEnabled = Boolean(getIsReferralRevampEnabled(constants));
  return { isRevampEnabled, isRevampFlagReady };
};

const useIsReferralRevampEnabled = useReferralRevampState;

export default useIsReferralRevampEnabled;
